module.exports = __webpack_public_path__ + "img/Linda Turner Formal.6548c6f8.jpeg";